import type { ResourceProps } from 'react-admin';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';

import GiftcardList from './GiftcardList';

const giftcardsResource: Omit<ResourceProps, 'children'> = {
  name: 'giftcards',
  list: GiftcardList,
  icon: CardGiftcardIcon,
  options: { label: 'Gift cards' },
};

export default giftcardsResource;
export { giftcardsDataProvider } from './dataProvider';
export type { GiftcardRecord } from './types';
